import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-end flex-shrink-0" }
const _hoisted_2 = { class: "d-flex align-center justify-center flex-grow-1" }

import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { setAxiosSessionCredentials } from '@/api/axiosSessionAuth';
import Sidebar from '@/components/ui/UiSidebar.vue';
import AuthForm from '@/components/Auth.vue';
import AppGlobalNotify from '@/components/AppGlobalNotify.vue';
import AppThemeToggleBtn from '@/components/ui/AppThemeToggleBtn.vue';
import {
  setAppReleaseUpgradeHandler,
  fetchAndObserveVersionJson,
} from '@/utils/appReleaseWatch';
import { getApiBaseUrl } from '@/config/backendBaseUrl';


const __default__ = { name: 'PriceListApp' };

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();

const updateCheckInterval = ref<ReturnType<typeof setInterval> | null>(null);
const isShouldUpdate = ref(false);

const userData = computed((): Record<string, unknown> => {
  const raw = store.getters['user/userData'];
  if (raw == null || (Array.isArray(raw) && raw.length === 0)) {
    return {};
  }
  return raw as Record<string, unknown>;
});

watch(
  userData,
  (val) => {
    if (val && val.auth && val.id != null) {
      setAxiosSessionCredentials(val.id, (val.hash as string) ?? '');
    } else {
      setAxiosSessionCredentials(null, null);
    }
  },
  { deep: true, immediate: true }
);

function reloadThisPage() {
  window.location.reload();
}

async function pollVersionJson() {
  await fetchAndObserveVersionJson(getApiBaseUrl());
}

function startUpdateChecker() {
  void pollVersionJson();
  updateCheckInterval.value = setInterval(() => {
    void pollVersionJson();
  }, 5 * 60 * 1000);
}

function showUpdateNotification() {
  isShouldUpdate.value = true;
}

setAppReleaseUpgradeHandler(() => {
  showUpdateNotification();
});

onMounted(() => {
  let userDataLS: Record<string, unknown> = {};
  try {
    userDataLS = JSON.parse(localStorage.getItem('userData') || 'null') || {};
  } catch {
    userDataLS = {};
  }
  if (userDataLS.auth) {
    const groups = userDataLS.groups;
    if (Array.isArray(groups)) {
      userDataLS = {
        ...userDataLS,
        groups: groups.map((role: unknown) => parseInt(String(role), 10)),
      };
    }
    store.commit('user/setUserData', userDataLS);
  }
  startUpdateChecker();
});

onBeforeUnmount(() => {
  if (updateCheckInterval.value != null) {
    clearInterval(updateCheckInterval.value);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { class: "price-app" }, {
    default: _withCtx(() => [
      _createVNode(AppGlobalNotify),
      (userData.value.auth)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(Sidebar),
            _createVNode(_component_v_snackbar, {
              modelValue: isShouldUpdate.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isShouldUpdate).value = $event)),
              timeout: 60000,
              location: "top",
              color: "orange-darken-4"
            }, {
              actions: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "white",
                  variant: "outlined",
                  size: "small",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (reloadThisPage()))
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("b", null, "Обновить", -1)
                  ]))]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _cache[3] || (_cache[3] = _createTextVNode(" ВЫШЛА НОВАЯ ВЕРСИЯ ПРАЙСА ", -1))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 64))
        : (_openBlock(), _createBlock(_component_v_main, {
            key: 1,
            class: "auth-shell d-flex flex-column pa-4",
            style: {"min-height":"100vh"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(AppThemeToggleBtn)
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(AuthForm)
              ])
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}
}

})